module.exports = __webpack_public_path__ + "static/media/route_path_direction.43f873b0.svg";